import React, { useState } from "react";

export default function HomeWareManagement() {
  const [activeImage, setActiveImage] = useState("choose1"); // default open image
  const [activeAccordion, setActiveAccordion] = useState("collapseOne"); // default open card

  const images = {
    choose1: "/assets/images/warehouse-image1.webp",
    choose2: "/assets/images/coonectivity-img1.webp",
    choose3: "/assets/images/coonectivity-img2.webp",
  };

  const toggleAccordion = (id, imgKey) => {
    setActiveAccordion(activeAccordion === id ? null : id);
    setActiveImage(imgKey);
  };

  return (

    <>

      <section className="warehouse-management">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-9">
              <div className="warehouse-text heading-gap ">
                <h3 className="heading heading-center">Seamless & Smart Warehouse Management</h3>
              </div>
            </div>
          </div>

          <div className="row align-items-center">
            {/* Images */}
            <div className="col-lg-6 col-md-6 order-2 order-lg-6 order-md-1">
              <div className="warehouse-image-wrapper">
                {Object.keys(images).map((key) => (
                  <div key={key} className="warehouse-img-col" style={{ display: activeImage === key ? "block" : "none" }}  >
                    <div className="col-inner">
                      <img src={images[key]} className="img-responsive" alt="Warehouse" loading="lazy" />
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Accordion */}
            <div className="col-lg-6 col-md-6 order-1 order-lg-6 order-md-2">
              <div className="accordion warehouse-accord">
                {/* Item 1 */}
                <div className={`card ${activeAccordion === "collapseOne" ? "active" : ""}`} >
                  <div className="card-header">
                    <button className="btn btn-link" onClick={() => toggleAccordion("collapseOne", "choose1")}  >
                      <span>
                        <label><img src="/assets/images/warehouse-icon1.webp" alt="Icon" className="img-responsive" /></label> Optimise Inbound Operations
                      </span>
                    </button>
                  </div>
                  <div id="collapseOne" className={`collapse ${activeAccordion === "collapseOne" ? "show" : ""}`}>
                    <div className="card-body">
                      <p>
                        Reduce dock-to-stock cycle times by streamlining inventory storage. Prevent shrinkage with shelf-life management and maintain accuracy with unit level tracking using serial numbers.

                      </p>
                    </div>
                  </div>
                </div>

                {/* Item 2 */}
                <div className={`card ${activeAccordion === "collapseTwo" ? "active" : ""}`}  >
                  <div className="card-header">
                    <button className="btn btn-link" onClick={() => toggleAccordion("collapseTwo", "choose2")}   >
                      <span>
                        <label><img src="/assets/images/warehouse-icon2.webp" alt="Icon" className="img-responsive" /></label> Scalable Connectivity
                      </span>
                    </button>
                  </div>
                  <div id="collapseTwo" className={`collapse ${activeAccordion === "collapseTwo" ? "show" : ""}`} >
                    <div className="card-body">
                      <p>
                        Integrate effortlessly with REST APIs, ERPs, and planning solutions like SAP, Oracle, NetSuite, and Microsoft Dynamics. Highly configurable to connect seamlessly with OMS, TMS, and other enterprise systems.
                      </p>
                    </div>
                  </div>
                </div>

                {/* Item 3 */}
                <div className={`card ${activeAccordion === "collapseThree" ? "active" : ""}`}  >
                  <div className="card-header">
                    <button className="btn btn-link" onClick={() => toggleAccordion("collapseThree", "choose3")} >
                      <span>
                        <label><img src="/assets/images/warehouse-icon3.webp" alt="Icon" className="img-responsive"  loading="lazy"/></label> Mobile WMS Productivity
                      </span>
                    </button>
                  </div>
                  <div id="collapseThree" className={`collapse ${activeAccordion === "collapseThree" ? "show" : ""}`}  >
                    <div className="card-body">
                      <p>
                        Empower your warehouse with paperless operations via a mobile app. Assign tasks with role-based access, optimize picking and put away paths, and minimize errors with scan-based processes.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* Accordion End */}
          </div>
        </div>
      </section>

      <div className="border-left"><span></span></div>
    </>
  );
}
